(function () {
    'use strict';
    angular.module('Directives').directive('bbaAccountingInsuranceDetails', bbaAccountingInsuranceDetails);
    bbaAccountingInsuranceDetails.$inject = [];

    function bbaAccountingInsuranceDetails() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/accounting/bbaAccountingInsuranceDetails.html',
            require: '^form',
            scope: {
                ngModel: '=',
                label: '=',
                currency: '=',
                isViewMode: '='
            },
            link: bbaAccountingInsuranceDetailsLink
        }

        function bbaAccountingInsuranceDetailsLink($scope) {
            const vm = this;
            console.log($scope)

        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaAccountingInsuranceDetails.js